import { path } from 'ramda';

export const selectLoading = path(['page', 'loading']);
